import {
  CUSTOMER_APPLICATION_DEVELOPER,
  CUSTOMER_DIVISION,
  CUSTOMER_MERCHANT,
  CUSTOMER_PSP,
  CUSTOMER_VOLT,
} from "../../models/Customer";

const customers = {
  [CUSTOMER_MERCHANT]: "Merchant",
  [CUSTOMER_PSP]: "Payment service provider",
  [CUSTOMER_DIVISION]: "Division",
  [CUSTOMER_APPLICATION_DEVELOPER]: "Application developer",
  [CUSTOMER_VOLT]: "Special Volt Customer",

  checkoutBrandingInactiveMessage:
    "Branding is not active, checkout uses default Volt branding",
  companyLogoRequirements: "Please provide images, max. size: {{maxSizeMB}}MB",
  companyLogoRecommendedRatio: "Recommended aspect ratio {{ratio}}",
};

export default customers;
